import { useEffect } from "react"

export const useBuyButton = (productId, elementId) => {
  const scriptURL =
    "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js"

  useEffect(() => {
    if (window.ShopifyBuy) {
      if (window.ShopifyBuy.UI) {
        ShopifyBuyInit()
      } else {
        loadScript()
      }
    } else {
      loadScript()
    }
  }, [])

  function loadScript() {
    var script = document.createElement("script")
    script.async = true
    script.src = scriptURL
    ;(
      document.getElementsByTagName("head")[0] ||
      document.getElementsByTagName("body")[0]
    ).appendChild(script)
    script.onload = ShopifyBuyInit
  }

  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: "ohema-by-eba.myshopify.com",
      storefrontAccessToken: "80242238f612db12616a23d5027d8ce3",
    })
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent("product", {
        id: productId,
        node: document.getElementById(elementId),
        moneyFormat: "%24%7B%7Bamount%7D%7D",
        options: {
          product: {
            styles: {
              product: {
                "@media (min-width: 601px)": {
                  "max-width": "calc(25% - 20px)",
                  "margin-left": "20px",
                  "margin-bottom": "50px",
                },
              },
              button: {
                ":hover": {
                  "background-color": "#292929",
                },
                "background-color": "#181818",
                ":focus": {
                  "background-color": "#292929",
                },
                "padding-left": "100px",
                "padding-right": "100px",
              },
            },
            buttonDestination: "checkout",
            contents: {
              img: false,
              title: false,
              price: false,
            },
            text: {
              button: "Buy now",
            },
          },
          productSet: {
            styles: {
              products: {
                "@media (min-width: 601px)": {
                  "margin-left": "-20px",
                },
              },
            },
          },
          modalProduct: {
            contents: {
              img: false,
              imgWithCarousel: true,
              button: false,
              buttonWithQuantity: true,
            },
            styles: {
              product: {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px",
                },
              },
              button: {
                ":hover": {
                  "background-color": "#292929",
                },
                "background-color": "#181818",
                ":focus": {
                  "background-color": "#292929",
                },
              },
            },
            text: {
              button: "Add to cart",
            },
          },
          option: {},
          cart: {
            styles: {
              button: {
                ":hover": {
                  "background-color": "#292929",
                },
                "background-color": "#181818",
                ":focus": {
                  "background-color": "#292929",
                },
              },
            },
            text: {
              total: "Subtotal",
              button: "Checkout",
            },
          },
          toggle: {
            styles: {
              toggle: {
                "background-color": "#181818",
                ":hover": {
                  "background-color": "#292929",
                },
                ":focus": {
                  "background-color": "#292929",
                },
              },
            },
          },
        },
      })
    })
  }
}
